export default function acceptAllConsent(): void {
  if (typeof window.OneTrust === "undefined") {
    setTimeout(acceptAllConsent, 50);
    return;
  }
  window.OneTrust.AllowAll();
}
